import React, { createContext, useContext, useState } from "react";

const DrawerContext = createContext();

export const DrawerProvider = ({ children }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [editingCustomer, setEditingCustomer] = useState(null);
  const [editingDealer, setEditingDealer] = useState(null);
  const [mode, setMode] = useState("add");
  const [drawerType, setDrawerType] = useState("customer"); // "customer" or "dealer"
  const [redirectPath, setRedirectPath] = useState(null);

  const toggleDrawer = () => {
    setIsDrawerOpen((prev) => !prev);
    if (!isDrawerOpen) {
      setMode("add");
      setRedirectPath(null);
      setDrawerType("customer");
    }
  };

  // Customer operations
  const openDrawerWithCustomer = (fullCustomerData, path = null) => {
    setEditingCustomer(fullCustomerData);
    setEditingDealer(null);
    setMode("edit");
    setDrawerType("customer");
    setRedirectPath(path);
    setIsDrawerOpen(true);
  };

  const openDrawerForAddCustomer = () => {
    setEditingCustomer(null);
    setEditingDealer(null);
    setMode("add");
    setDrawerType("customer");
    setRedirectPath(null);
    setIsDrawerOpen(true);
  };

  // Dealer operations
  const openDrawerWithDealer = (fullDealerData, path = null) => {
    setEditingDealer(fullDealerData);
    setEditingCustomer(null);
    setMode("edit");
    setDrawerType("dealer");
    setRedirectPath(path);
    setIsDrawerOpen(true);
  };

  const openDrawerForAddDealer = () => {
    setEditingDealer(null);
    setEditingCustomer(null);
    setMode("add");
    setDrawerType("dealer");
    setRedirectPath(null);
    setIsDrawerOpen(true);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
    setEditingCustomer(null);
    setEditingDealer(null);
    setMode("add");
    setDrawerType("customer");
    setRedirectPath(null);
  };

  return (
    <DrawerContext.Provider
      value={{
        isDrawerOpen,
        toggleDrawer,
        // Customer methods
        openDrawerWithCustomer,
        openDrawerForAddCustomer,
        editingCustomer,
        // Dealer methods
        openDrawerWithDealer,
        openDrawerForAddDealer,
        editingDealer,
        // Shared properties
        mode,
        drawerType,
        redirectPath,
        closeDrawer,
      }}
    >
      {children}
    </DrawerContext.Provider>
  );
};

export const useDrawer = () => useContext(DrawerContext);